import { useMatches, useRouter } from "@tanstack/react-router";

export function useGameRoute() {
  const router = useRouter();
  const matches = useMatches();
  const match = matches.at(-1);

  if (!match) throw new Error("Game routes require an active router match");

  const location = router.buildLocation({
    to: match.pathname,
    search: match.search,
    hash: "",
  });

  return {
    href: location.pathname + location.searchStr,
    isGameRoute: matches.some(
      ({ routeId }) =>
        routeId === "/_site/$coworld" || routeId === "/_site/unlisted/$coworld",
    ),
  };
}
